$(function($, win)
{
    $.fn.inViewport = function(cb)
    {
        return this.each( function( i, el )
        {
            function visPx()
            {
                var H = $( this ).height(),
                r = el.getBoundingClientRect(), t = r.top, b = r.bottom;
                return cb.call( el, Math.max( 0, t > 0 ? H - t : ( b < H ? b : H ) ) );
            }visPx();
            $( win ).on( "resize scroll", visPx );
        });
    };
}( jQuery, window ) );


$( function( $ ) {
    $( ".number-count" ).inViewport(function(px)
    {
        if( px > 100 && !this.initNumAnim )
        {
            this.initNumAnim = true;
            $( this ).prop( 'Counter', 0 ).animate(
            {
                Counter: $( this ).data( "number-count" )
            },
            {
                duration: 5000,
                step: function( now )
                {
                    $( this ).text( Math.ceil( now ) );
                }
            } );
        }
    });
});